"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processedFormsOrdinals = exports.processedFormsConditions = exports.processedForms = void 0;
const all_forms_1 = require("./definitions/forms/all-forms");
const process_1 = require("./generator/process");
const { processedForms, processedFormsConditions, processedFormsOrdinals } = (0, process_1.process)(all_forms_1.allForms);
exports.processedForms = processedForms;
exports.processedFormsConditions = processedFormsConditions;
exports.processedFormsOrdinals = processedFormsOrdinals;
